import { getField, updateField } from 'vuex-map-fields'
import api from '@/api/api'
import { PlanoPagamento } from '@/models/PlanoPagamento'
import Swal from 'sweetalert2'
// import { v4 } from 'uuid'

export const SET_STATE = 'SET_STATE'
export const BOOTSTRAP_PROFILE = 'BOOTSTRAP_PROFILE'
export const LOAD_PLANOS_PAGAMENTO = 'LOAD_PLANOS_PAGAMENTO'
export const LOAD_ROLES = 'LOAD_ROLES'
export const SUBMIT = 'SUBMIT'
export const RESET_STATE = 'RESET_STATE'

const getDefaultState = () => {
  return {
    planos: [],
    step: 1,
    loading: true,
    isEditing: false,
  }
}

const state = getDefaultState()

const getters = {
  getField,
}

const mutations = {
  updateField,
  [RESET_STATE] (state) {
    Object.assign(state, getDefaultState())
  },
  [SET_STATE] (state, payload) {
    Object.assign(state, payload)
  },
}

const actions = {
  async [BOOTSTRAP_PROFILE] ({ dispatch, commit, state }, { id }) {
    commit(RESET_STATE)
    commit(SET_STATE, { loading: true, isEditing: false })
    dispatch('form/BOOTSTRAP_FORM', { model: new PlanoPagamento() }, { root: true })
    if (id) {
      commit(SET_STATE, { isEditing: true })
      await api.getEntidade('plano-pagamento', id).then(response => {
        dispatch('form/BOOTSTRAP_FORM', { model: new PlanoPagamento(response.data) }, { root: true })
      })
    }
    commit(SET_STATE, { loading: false })
  },
  async [SUBMIT] ({ commit, dispatch, state, rootState }, { router, user }) {
    Swal.fire({
      title: 'Enviando dados!',
      timerProgressBar: true,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading()
      },
      didOpen: () => {
        const form = { ...rootState.form.data };
        (() => {
          commit('SET_STATE', { loading: true })
          return state.isEditing
            ? api.salvarEntidade(form, 'plano-pagamento', form.id)
            : api.cadastrarEntidade(form, 'plano-pagamento')
        })().then(
          data => {
            Swal.fire({
              title: state.isEditing
                ? 'Plano de Pagamento atualizado com sucesso!'
                : 'Plano de Pagamento cadastrado com sucesso!',
              icon: 'success',
              showConfirmButton: false,
              timer: 1500,
            })

            dispatch('planosPagamento/BOOTSTRAP', null, { root: true })
            router.push({
              path: `/${user.get().role}/cdc/plano-pagamento`,
            })
          },
          error => {
            commit('SET_STATE', { loading: false })
            Swal.fire({
              icon: 'error',
              title: 'Atenção',
              text: error.message,
            })
          },
        )
      },
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
